export interface ISecurityAppActionData {
  appActionId: string;
  appActionDescription: string;
}
